import React from "react";
import PopupModules from "src/features/auth/components/PopupModules";

export default function OrderSearchModal({
    open,
    orderId,
    setOrderId,
    onSearch,
    onClose
}: any) {
    return (
        <PopupModules isOpen={open} onClose={onClose} title="Order Search">
            <div className="p-4 space-y-3">
                <input
                    className="border p-2 rounded w-full"
                    placeholder="Enter Order ID"
                    value={orderId}
                    onChange={(e) => {
                        let value = e.target.value
                            .toUpperCase()
                            .replace(/[^A-Z0-9]/g, "")
                            .slice(0, 8);

                        setOrderId(value);
                    }}
                />

                <div className="flex justify-end gap-2">
                    <button onClick={onClose} className="px-3 py-1 border rounded">
                        Cancel
                    </button>
                    <button onClick={onSearch} className="bg-blue-500 text-white px-4 py-1 rounded">
                        Find Order
                    </button>
                </div>
            </div>
        </PopupModules>
    );
}